import { InjectionToken } from '@angular/core';

import { SnackBarRef } from '../models/snackbar-ref.model';

export const SNACKBAR_REF = new InjectionToken<SnackBarRef>(
  'SnackBar Reference',
);
